import { render, staticRenderFns } from "./swuserregpwd.vue?vue&type=template&id=88da2c50&scoped=true&"
import script from "./swuserregpwd.vue?vue&type=script&lang=js&"
export * from "./swuserregpwd.vue?vue&type=script&lang=js&"
import style0 from "./swuserregpwd.vue?vue&type=style&index=0&id=88da2c50&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "88da2c50",
  null
  
)

export default component.exports